import React from "react";
import Section from "../ui/Section";
import { skillGroups } from "../../data/profile";

function Skills() {
  return (
    <Section
      id="skills"
      eyebrow="Skills"
      title="Technical toolkit"
      subtitle="Languages, frameworks, and fundamentals I work with day to day."
    >
      <div className="grid grid--3">
        {skillGroups.map((group) => (
          <article className="card" key={group.id}>
            <h3 className="skill-card__title">{group.title}</h3>
            <ul className="chips">
              {group.skills.map((skill) => (
                <li className="chip" key={skill}>
                  {skill}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </Section>
  );
}

export default Skills;
